import { render } from "./PanelSettingsMenu.vue?vue&type=template&id=5085305a"
import script from "./PanelSettingsMenu.vue?vue&type=script&lang=js"
export * from "./PanelSettingsMenu.vue?vue&type=script&lang=js"

import "./PanelSettingsMenu.vue?vue&type=style&index=0&id=5085305a&lang=css"

import exportComponent from "/var/www/service/service-cp-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__